
export enum AlgoliaEntity {
    Ballot = 1,
    Project = 2,
    Publication = 3,
    Committee = 4
}
